import { createContext, useContext } from 'react'
import { AuthStore } from './AuthStore'
import { TenantStore } from './TenantStore'
import { GuestStore } from './GuestStore'
import { RoomStore } from './RoomStore'
import { UserStore } from './UserStore'
import { SettingStore } from './SettingStore'
import { ActivateStore } from './ActivateStore'
import mitt from 'mitt'

export type TypedEvents = {
  changeTenantId: string
}

export const events = mitt<TypedEvents>()

export class RootStore {
  authStore: AuthStore
  tenantStore: TenantStore
  guestStore: GuestStore
  roomStore: RoomStore
  userStore: UserStore
  settingStore: SettingStore
  activateStore: ActivateStore

  constructor() {
    this.authStore = new AuthStore()
    this.tenantStore = new TenantStore(this.authStore)
    this.guestStore = new GuestStore()
    this.roomStore = new RoomStore()
    this.userStore = new UserStore()
    this.settingStore = new SettingStore()
    this.activateStore = new ActivateStore()
  }
}

export const rootStore = new RootStore()

export const StoreContext = createContext<RootStore>(rootStore)

export const useStore = () => {
  const store = useContext(StoreContext)
  if (!store) {
    throw new Error('useStore must be used within a StoreProvider')
  }
  return store
}

export const useStores = useStore // Alias for backward compatibility

export const useAuthStore = () => useStore().authStore
export const useTenantStore = () => useStore().tenantStore
export const useGuestStore = () => useStore().guestStore
export const useRoomStore = () => useStore().roomStore
export const useUserStore = () => useStore().userStore
export const useSettingStore = () => useStore().settingStore
export const useActivateStore = () => useStore().activateStore

export default rootStore